//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import moment from 'moment'
export default {
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      Currentyear: moment(new Date()).format('YYYY') // 当前年渲染列表要用
    }
  },
  created () {

  },
  mounted () {

  },
  methods: {
    Jumpdetails () {
      window.open(`/${this.$store.state.LanguageCode}/live/${this.item.livecode}.html`)
    }
  }
}
